module.exports = __webpack_public_path__ + "res/img/male.7338d47a.png";